/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-p1.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-p2.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-p3.png",

    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-p1-2.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-p2-2.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-p3-2.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-p1-3.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-p2-3.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-p3-3.png",

    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-c1.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-c2.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-c3.png",
    "https://cdn.shopify.com/s/files/1/0620/5571/0877/files/20250625-c4.png",
  ];

  new Swiper(".sp-swiper-btn", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      reverseDirection: true,
      delay: 4000,
    },
    slidesPerView: 1,

    loop: true,
  });

  let _swiper = new Swiper(".swiper-p2", {
    spaceBetween: 10,
    slidesPerView: 1,
    speed: 1,
  });
  let _swiper2 = new Swiper(".swiper-p3", {
    spaceBetween: 10,
    slidesPerView: 1,
    speed: 1,
  });

  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");

      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() +
          $(".sp-header-top").height() +
          $(".sp-nav").height() +
          50;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();
  let sp_price1 = 23.99;
  let sp_price2 = 49.99;

  function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }
  let prods = window.product
  $('.product-part-inner #sp_price1').html((prods[0].price /100).toFixed(2))
  $('.product-part-inner #sp_price2').html((prods[0].compare_at_price /100).toFixed(2))
  $('.sp-mask #sp_price1').html((prods[0].price /100).toFixed(2))
  $('.sp-mask #sp_price2').html((prods[0].compare_at_price /100).toFixed(2))
  function getCur(productPart){
    let style = productPart.find('#sp-number div.active').attr('data-val')
    let size = productPart.find('#sp-color div.active').attr('data-val')
    return prods.filter(item=> item.option1 == style && item.option2 == size)[0]
  }
  function changePrice(productPart){
    let num = productPart.find('#calcNumber').val()
    let price = (getCur(productPart).price * num / 100).toFixed(2)
    let compare = (getCur(productPart).compare_at_price * num / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    console.log(price)
    productPart.find('#sp_price1').html(price)
    productPart.find('#sp_price2').html(compare)
    let off_font = 100 - Math.ceil(getCur(productPart).price / getCur(productPart).compare_at_price * 100)
    $(".product-part .price-group .sp-row span").html(off_font);
  }
  $('.sp-btn-style').click(function(){
    let productPart = $(this).closest('.product-part');
    let num = productPart.find('#calcNumber').val()
    window.location.href = '/cart/' + getCur(productPart).id + ':' + num
  })
  function showTip() {
    // let result = $("#sp_price1").html();
    // if (result >= 50) {
    //   $(".product-part .sp-btn-tip").show();
    // } else {
    //   $(".product-part .sp-btn-tip").hide();
    // }
  }
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    let productPart = $(this).closest('.product-part');
    if (num > 0) {
      input.value = num;
    }
    changePrice(productPart)
    showTip();
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    let productPart = $(this).closest('.product-part');
    input.value = num;
    changePrice(productPart)
    showTip();
  });

  $(".product-part-inner .sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let productPart = $(this).closest('.product-part');
    let colorOptions = $(
      ".product-part-inner #sp-color .sp-option.active"
    ).index();
    let numOptions = $(
      ".product-part-inner  #sp-number .sp-option.active"
    ).index();
    console.log(colorOptions,numOptions)
    let _index = colorOptions + numOptions * 3;

    _swiper.slideTo(_index);
    changePrice(productPart)
  });
  $(".sp-mask .product-part .sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    let productPart = $(this).closest('.product-part');

    let colorOptions = $(
      ".sp-mask .product-part #sp-color .sp-option.active"
    ).index();
    let numOptions = $(
      ".sp-mask .product-part #sp-number .sp-option.active"
    ).index();

    let _index = colorOptions + numOptions * 3;

    _swiper2.slideTo(_index);
    changePrice(productPart)
  });

  // 展示尺码弹窗
  $(".sp-btn-pop").click(function () {
    $(".sp-mask").css("display", "flex");
    // $(".sp-pop").show();
  });
  // 关闭弹窗按钮

  $(".sp-close-btn").click(function (e) {
    $(".sp-mask").hide();
    // $(".sp-pop").hide();
  });

  const tabs = $(".sp-tab");

  let currentIndex = 0; // 当前展示的tab索引

  function nextTabFunc() {
    const currentTab = tabs[currentIndex];
    // 当前tab开始动画
    currentTab.classList.add("sp-tab-ani");

    let nextIndex = (currentIndex + 1) % tabs.length;
    const nextTab = tabs[nextIndex];

    setTimeout(() => {
      currentTab.classList.remove("sp-tab-ani");
    }, 2500);

    currentIndex = (currentIndex + 1) % tabs.length;
    setTimeout(nextTabFunc, 1500);
  }

  // nextTabFunc();
  // 开始动画循环
  // setTimeout(nextTab, 1500); // 可以根据需要设置初始延迟

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");
    const paragraph2 = gradually.querySelector(".sp-title-color");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            if (paragraph) {
              const totalDelay = spans.length * 0.1 + 0.3;
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }
            if (paragraph2) {
              const totalDelay = spans.length * 0.1 + 0.3;
              paragraph2.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph2.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }

  $(function () {
    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
      let productPart = $(this).closest('.product-part');
      var data = {
      id: getCur(productPart).id,
      quantity: productPart.find('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
          $('.sp-cart .sp-num').removeClass('sp-gray')
        });
      },
      dataType: "json",
    });
      var img = $(".product-part .swiper .swiper-slide-active .sp-img-p");
      var flyer = img[0].cloneNode(true);
      flyer.classList.add("sp_clone");

      $(".product-part").append(flyer);
      $(".sp_clone").css({
        width: img[0].width,
        height: img[0].height,
        background: "#e7e9ef",
        position: "fixed",
        top: img[0].offsetTop,
        left: img.offset().left,
        "z-index": "99",
      });

      let finish = $(".sp-cart");
      $(".sp_clone").animate(
        {
          top: finish[0].offsetTop,
          // top: finish[0].offsetTop + $(".time-part").height(),
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        500,
        "linear",
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach();
            }
          );
        }
      );
    });
  });
});
